import { IHexGridData } from 'js/bubbleCore/types';
import { hashToColRow } from 'js/bubbleCore/utils/hash';

export function filterGrid<T>(
  grid: IHexGridData<T>,
  callback: (value: T, col: number, row: number) => boolean): T[] {
  return Object.entries(grid.values)
    .filter(([hash, bubble]) => callback(bubble, ...hashToColRow(hash)))
    .map(([hash, bubble]) => bubble);
}